import {Component, Input, NgZone, OnInit, ViewChild} from '@angular/core';
import {IonContent, IonSegment} from '@ionic/angular';
import {FeedService} from 'src/app/services/feed/feed.service';
import {GlobalService} from 'src/app/services/global/global.service';
import {ApiResponse} from 'src/app/services/utils';
import {SwiperOptions} from 'swiper';
import {SwiperComponent} from 'swiper/angular';

@Component({
  selector: 'app-action-point',
  templateUrl: 'action-point.page.html',
  styleUrls: ['action-point.page.scss'],
  standalone: false
})
export class ActionPointPage implements OnInit {
  @ViewChild(IonContent, {static: false}) apcontent: IonContent;
  @ViewChild('swiper') swiper: SwiperComponent;
  @ViewChild('segment') segment: IonSegment;
  @Input('component') component: boolean = false;

  actionPoints = [];
  totalActionPoints = 0;
  page = 1;
  impactResponseFlag = false;
  type = 'newest';

  config: SwiperOptions = {
    pagination: true,
    height: 400
  };

  activeSegment: string;
  loading = false;
  isWeb: boolean = false;

  constructor(
    private feedService: FeedService,
    private globalService: GlobalService,
    private zone: NgZone
  ) {
  }

  ngOnInit(): void {
    this.isWeb = this.globalService.isWeb;
    this.loadActionPoints();

    this.globalService.homeScrollTop.subscribe(val => {
      if (val !== null && val === 'action-point') {
        this.apcontent.scrollToTop();
        this.loadActionPoints();
      }
    });
  }

  doRefresh(event) {
    setTimeout(() => {
      this.loadActionPoints();
      event.target.complete();
    }, 1000);
  }

  loadActionPoints() {
    if (this.impactResponseFlag) return;

    this.impactResponseFlag = true;
    this.loading = true;

    this.page = 1;
    this.actionPoints = [];

    this.feedService.getActionPointList(this.page, this.type)
      .subscribe((result: ApiResponse) => {
        if (result.status) {
          this.actionPoints = [...result.data.data];
          this.totalActionPoints = result.data.pagination?.total;
          this.page++;
        }

        this.loading = false;
        this.impactResponseFlag = false;
      });
  }


  loadMoreActionPoint(event) {
    this.loading = true;
    if (this.impactResponseFlag === false) {
      this.impactResponseFlag = true;

      this.feedService.getActionPointList(this.page, this.type).subscribe((result: ApiResponse) => {
        if (result.status) {
          result.data.data.forEach(element => {
            this.actionPoints.push(element);
          });
          this.page++;
        }
        event.target.complete();
        this.impactResponseFlag = false;
        this.loading = false;
      });
    }
  }

  onSlideChange(event) {
    this.zone.run(() => {
      const index = event[0].activeIndex;

      if (index === 0) this.type = 'newest';
      if (index === 1) this.type = 'top';
      if (index === 2) this.type = 'discover';

      this.segment.value = this.type;
      this.loadActionPoints();
    });
  }


  segmentChanged(event) {
    const value = event.detail.value;

    if (value === 'newest') this.swiper.swiperRef.slideTo(0);
    if (value === 'top') this.swiper.swiperRef.slideTo(1);
    if (value === 'discover') this.swiper.swiperRef.slideTo(2);
  }

}

